const accordionTitles = document.querySelectorAll(".accordionTitle");

accordionTitles.forEach((accordionTitle) => {
    accordionTitle.addEventListener("click", () => {
        if (accordionTitle.classList.contains("is-open")) {
            accordionTitle.classList.remove("is-open");
            accordionTitle.parentNode.classList.remove("parent-is-open"); // Remove class from parent
            // Remove class from grandparent
            accordionTitle.parentNode.parentNode.classList.remove("grandparent-is-open");
        } else {
            const accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
            accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
                accordionTitleWithIsOpen.classList.remove("is-open");
                accordionTitleWithIsOpen.parentNode.classList.remove("parent-is-open"); // Remove class from parent
                // Remove class from grandparent
                accordionTitleWithIsOpen.parentNode.parentNode.classList.remove("grandparent-is-open");
            });
            accordionTitle.classList.add("is-open");
            accordionTitle.parentNode.classList.add("parent-is-open"); // Add class to parent
            // Add class to grandparent
            accordionTitle.parentNode.parentNode.classList.add("grandparent-is-open");
        }
    });
});
